module.exports = __webpack_public_path__ + "img/icon-info.4a7b86a4.svg";